<template>
  <div class="box">
    <div class="thank">謝謝</div>
    <div class="finish">您已完成所有測試！</div>
  </div>
</template>

<script>
export default {
  name: "TestFinishTips"
}
</script>

<style scoped>
  .box{
    text-align: center;
  }
  .thank{
    font-size: var(--ecs-font-lg);
    color: #61005f;
  }
  .finish{
    font-size: var(--ecs-font-lg);
  }
</style>
